import type { ValueOf } from '@common/utils/utilityTypes';

// Alcoholconsumptie gebruiksgedrag
export const AlcoholconsumptieGebruiksgedrag = {
    drinkt_momenteel_niet: 'Drinkt momenteel niet',
    dronk_vroeger_alcohol: 'Dronk vroeger alcohol',
    levenslange_niet_drinker: 'Levenslange niet-drinker',
} as const;
export type AlcoholconsumptieGebruiksgedrag = ValueOf<typeof AlcoholconsumptieGebruiksgedrag>;
export const alcoholconsumptieNeeGebruiksgedragOptions = [
    AlcoholconsumptieGebruiksgedrag.levenslange_niet_drinker,
    AlcoholconsumptieGebruiksgedrag.dronk_vroeger_alcohol,
    AlcoholconsumptieGebruiksgedrag.drinkt_momenteel_niet,
];

// Drugsgebruik gebruiksgedrag
export const DrugsgebruikGebruiksgedrag = {
    gebruikt_geen_drugs: 'Gebruikt geen drugs',
    heeft_in_het_verleden_drugs_gebruikt: 'Heeft in het verleden drugs gebruikt',
    heeft_nooit_drugs_gebruikt: 'Heeft nooit drugs gebruikt',
} as const;
export type DrugsgebruikGebruiksgedrag = ValueOf<typeof DrugsgebruikGebruiksgedrag>;
export const drugsgebruikNeeGebruiksgedragOptions = [
    DrugsgebruikGebruiksgedrag.heeft_nooit_drugs_gebruikt,
    DrugsgebruikGebruiksgedrag.gebruikt_geen_drugs,
    DrugsgebruikGebruiksgedrag.heeft_in_het_verleden_drugs_gebruikt,
];

// Locatie
export const Locatie = {
    bilateraal: 'Bilateraal',
    links: 'Links',
    rechts: 'Rechts',
} as const;
export type Locatie = ValueOf<typeof Locatie>;
export const locatieOptions: Locatie[] = [Locatie.links, Locatie.rechts, Locatie.bilateraal];

// Roken gebruiksgedrag
export const RokenGebruiksgedrag = {
    ex_roker: 'Ex-roker',
    niet_roker_maar_rookgedrag_in_verleden_onbekend: 'Niet-roker, maar rookgedrag in verleden onbekend',
    nooit_gerookt: 'Nooit gerookt',
    rookt_dagelijks: 'Rookt dagelijks',
    rookt_passief: 'Rookt passief',
    rookt_soms: 'Rookt soms',
} as const;
export type RokenGebruiksgedrag = ValueOf<typeof RokenGebruiksgedrag>;
export const rokenJaGebruiksgedragOptions = [RokenGebruiksgedrag.rookt_soms, RokenGebruiksgedrag.rookt_dagelijks];
export const rokenNeeGebruiksgedragOptions = [
    RokenGebruiksgedrag.rookt_passief,
    RokenGebruiksgedrag.nooit_gerookt,
    RokenGebruiksgedrag.niet_roker_maar_rookgedrag_in_verleden_onbekend,
    RokenGebruiksgedrag.ex_roker,
];

// Thuissituatie
export const Thuissituatie = {
    woontAlleen: 'Woont alleen',
    woontMetGezin: 'Woont met gezin',
    woontMetHuisgenoot: 'Woont met huisgenoot / huisgenoten',
    woontMetKinderen: 'Woont met kind / kinderen',
    woontMetOuders: 'Woont met ouder / ouders',
    woontMetPartner: 'Woont met partner',
} as const;
export type Thuissituatie = ValueOf<typeof Thuissituatie>;
export const thuissituatieOptions = [
    Thuissituatie.woontAlleen,
    Thuissituatie.woontMetPartner,
    Thuissituatie.woontMetKinderen,
    Thuissituatie.woontMetGezin,
    Thuissituatie.woontMetOuders,
    Thuissituatie.woontMetHuisgenoot,
];
